"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useWebChatUIContext = _interopRequireDefault(require("./useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useInternalMarkdownIt() {
  return (0, _useWebChatUIContext.default)().internalMarkdownItState;
}

var _default = useInternalMarkdownIt;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VJbnRlcm5hbE1hcmtkb3duSXQuanMiXSwibmFtZXMiOlsidXNlSW50ZXJuYWxNYXJrZG93bkl0IiwiaW50ZXJuYWxNYXJrZG93bkl0U3RhdGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVBLFNBQVNBLHFCQUFULEdBQWlDO0FBQy9CLFNBQU8sb0NBQXNCQyx1QkFBN0I7QUFDRDs7ZUFFY0QscUIiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0VUlDb250ZXh0IGZyb20gJy4vdXNlV2ViQ2hhdFVJQ29udGV4dCc7XG5cbmZ1bmN0aW9uIHVzZUludGVybmFsTWFya2Rvd25JdCgpIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRVSUNvbnRleHQoKS5pbnRlcm5hbE1hcmtkb3duSXRTdGF0ZTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgdXNlSW50ZXJuYWxNYXJrZG93bkl0O1xuIl19